import arriving from './arriving';
import qc from './qc';
import receiving from './receiving';

export default [...qc, ...arriving, ...receiving];
